import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import surveyStyles from '../survey.module.css';
import {
  addErrorMessageAction,
  clearMessagesAction,
  postSurveyResponseAction,
  clearQuestionResponsesAction
} from '../../../actions';
import { surveyType } from '../../../constants/types';
import { routes } from '../../../constants';
import withRouter from '../../WithRouter';
import { getCompiledPath } from '../../../util';

class SubmitSurveyButton extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      submitEnabled: true
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.submitEnabled && this.props.canSubmit()) {
      this.setState(() => ({ submitEnabled: false }));
      this.props.dispatchClearMessages();
      const surveyId = this.props.survey.id;
      const surveyResponse = {
        questionResponses: Object.values(this.props.questionResponses),
        researchConsentGiven: this.props.researchConsentGiven
      };

      this.props.dispatchPostSurveyResponse(surveyId, surveyResponse)
        .then(() => {
          this.props.dispatchClearResponses();
          this.props.navigate(getCompiledPath(routes.survey.responseSuccess, { surveyId }));
        })
        .catch((err) => this.props.dispatchAddErrorMessage(err));
    }
  }

  render() {
    const { survey: surveyData } = this.props;
    return (
      <Link
        className={`${surveyStyles.navButton} button--action ${this.state.submitEnabled ? '' : 'disabled'}`}
        onClick={this.handleSubmit}
        to={getCompiledPath(routes.survey.responseSuccess, { surveyId: surveyData.id })}
      >
        <Translate id="common.submit" />
      </Link>
    );
  }
}

const { func, bool, shape } = PropTypes;
SubmitSurveyButton.propTypes = {
  navigate: func.isRequired,
  survey: surveyType.isRequired,
  researchConsentGiven: bool.isRequired,
  questionResponses: shape().isRequired,
  dispatchPostSurveyResponse: func.isRequired,
  dispatchClearResponses: func.isRequired,
  dispatchClearMessages: func.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  canSubmit: func.isRequired
};

const mapStateToProps = ({ survey }) => ({
  survey: survey.surveyContent,
  questionResponses: survey.questionResponses,
  researchConsentGiven: survey.researchConsentGiven
});

const mapDispatchToProps = (dispatch) => ({
  dispatchPostSurveyResponse: (surveyId, responseData) =>
    dispatch(postSurveyResponseAction(surveyId, responseData)),
  dispatchClearResponses: () =>
    dispatch(clearQuestionResponsesAction()),
  dispatchClearMessages: () =>
    dispatch(clearMessagesAction()),
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SubmitSurveyButton)
);
